import * as React from 'react';
import {Helmet} from "react-helmet";
import "../sass/style.scss"

const Layout = ({children, pageTitle}) => {

    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content="Erleben Sie den Landtag aus einem neuen Blickwinkel. Mit einer Drohne geht es hoch hinaus und durch den Landtag." />
                <html lang="de"/>
            </Helmet>
            {children}
        </>
    )
}

export default Layout
